import { OrderDirection, ProjectComment, ProjectOrderByField, ProjectStage } from '@efficiently/models';

import { OrganizationFilter } from '@efficiently/client-api-projects';
import {
	DEFAULT_PROJECT_PAGINATION,
	type GetProjectsResult,
	type ProjectPaginationInput,
} from '@efficiently/client-domain-projects';
import { AutocompleteSearchOption } from '@efficiently/client-ui-common';

export class ProjectFilters {
	public searchQuery?: string;
	public searchField?: string;
	public status?: ProjectStage;
	public owner?: string;
	public organization?: string;
	public comments?: ProjectComment;
}

export class ProjectSorting {
	public orderBy: ProjectOrderByField;
	public orderDirection: OrderDirection;
}

export class ProjectOwner {
	public id: string;
	public name: string;
	constructor(id: string, name: string) {
		this.id = id;
		this.name = name;
	}
}

export type ProjectListItem = GetProjectsResult['projects'][number];

export type ProjectUi = ProjectListItem & {
	typeLabel?: string;
	viewOnly?: boolean;
	createdByName?: string;
	organization?: string;
};

export class ProjectListStateModel {
	constructor(
		public projects: ProjectUi[] = [],
		public pending: boolean = false,
		public sorting: ProjectSorting = {
			orderBy: ProjectOrderByField.lastViewedDate,
			orderDirection: OrderDirection.DESC,
		},
		public filters: ProjectFilters = {
			searchQuery: null,
			searchField: null,
			status: ProjectStage.Active,
			owner: null,
			organization: null,
			comments: ProjectComment.All,
		},
		public autocompleteSearchOptions: AutocompleteSearchOption[] = [],
		public pagination: ProjectPaginationInput = DEFAULT_PROJECT_PAGINATION,
		public projectOwners: ProjectOwner[] = [],
		public organizations: OrganizationFilter[] = [],
		public isFetchingAutocomplete: boolean = false,
		public clonedProjectId: string | null = null,
	) {}
}

export const defaults: ProjectListStateModel = new ProjectListStateModel();
